import { store } from 'redux/store';
import { isAuthenticated } from 'utils/auth';
import { apiInterceptor } from 'utils/apiInterceptor';
export async function GetNotifications(
    projectId,
    status = '',
    type = '',
    lastKey = '',
    search = '',
    timezone = ''
) {
    const user = store?.getState()?.user
    if (isAuthenticated() && user) {
        const response = await apiInterceptor(
            `${process.env.REACT_APP_MYXP_API_NOTIFICATION}/xpmgr/notifications/${projectId}?status=${status}&limit=10&type=${type}&lastKey=${lastKey}&search=${search}&timezone=${timezone}`,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            }
        );

        return await response.json();
    }
}
